module.exports = __webpack_public_path__ + "static/media/mm-min.52dea56b.mp4";